import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './Pill.scss';

/**
 * A basic pill component that supports multiple variants and styles.
 * This component is mostly unstyled if not used with a public class. See stylesheet for the supported public classes you can compose.
 * The base pill does not support any click handlers. If needed, handle the click event in the parent component using a button or link.
 * Any icon should be added using a ::before or ::after pseudo-elements, ideally in a composite component.
 *
 * @example
 * ```js
 * // JSX
 * <Pill className={styles.pill}>Pending</Pill>
 * <Pill className={styles.pill}>Active</Pill>
 * <Pill className={styles.pill}>Incomplete</Pill>
 * <Pill className={styles.pill}>Suspended</Pill>
 * <Pill className={styles.pill}>Closed</Pill>
 * <Pill className={styles.pill}>All</Pill>
 * ```
 *
 *
 * ```scss
 * // SCSS
 * .pill {
 *     composes: pill__public__status from '~@perpay-web/components/base/Pill/Pill.scss';
 *     composes: pill__public__status--success from '~@perpay-web/components/base/Pill/Pill.scss';
 * }
 * ```
 *
 * @param {Object} props
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 * @returns {React.ReactNode}
 */
const Pill = ({ children, className }) => (
    <span className={getClassName(styles.pill, className)}>{children}</span>
);

export default Pill;
